export const selectIsMini = (state) => state.sidebar.sessionMini ?? state.sidebar.isMini;
